import jQuery from "jquery"; //npm
window.$ = window.jQuery = jQuery;

window.bootstrap = require('bootstrap'); //npm

import "slick-carousel"; //npm

// WOW JS
import WOW from "wow.js"; //npm
new WOW().init();

// This is equivalent to $(document).ready()
$(function () {
  const hamburger = document.querySelector(".hamburger");
  const navLinks = document.querySelector(".nav-links");
  const links = document.querySelectorAll(".nav-links li");
  hamburger.addEventListener('click', ()=>{
    navLinks.classList.toggle("open");
    hamburger.classList.toggle("toggle");
  });

  document.querySelector(".search-error").addEventListener("animationend", removeAnimation);

  // Slick sliders
  $('.admail-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    prevArrow: "",
    nextArrow:"<img src='/images/right1.png' class='a-right-arrow'>",
    arrows:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  // TESTIMONIAL-SEC SLICK
  $('.testimonial-slider-section .slider').slick({
    dots: true,
    infinite: false,
    speed: 750,
    autoplay:true,
    arrows:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});


import lunr from "lunr";

let pagesIndex, searchIndex;
const MAX_SUMMARY_LENGTH = 100;
const WORD_REGEX = /\b(\w*)[\W|\s|\b]?/gm;

async function initSearchIndex() {
  try {
    let pagesFile = await fetch('/search-raw.json');
    pagesIndex = await pagesFile.json();

    const indexFile = await fetch('/search-index.json');
    const index = await indexFile.json();
    searchIndex = lunr.Index.load(index);
  } catch (e) {
    console.log(e);
  }
}

const form = document.getElementById('search-form');
form.onsubmit = (event) => {
  event.preventDefault();

  const query = document.getElementById("search").value.trim().toLowerCase();
  if (!query) {
    hideSearchResults();

    displayErrorMessage("Please enter a search term");
    return;
  }
  const results = searchSite(query);
  if (!results.length) {
    displayErrorMessage("Your search returned no results");
    return;
  }
  renderSearchResults(query, results);
}

function displayErrorMessage(message) {
  document.querySelector(".search-error").innerHTML = message;
  document.querySelector(".search-error").classList.remove("hide-element");
  document.querySelector(".search-error").classList.add("showAndFade");
}

function removeAnimation() {
  this.classList.remove("showAndFade");
  this.classList.add("hide-element");
}

function searchSite(query) {
  const originalQuery = query;
  query = getLunrSearchQuery(query);
  let results = getSearchResults(query);
  return results.length
        ? results
        : query !== originalQuery
            ? getSearchResults(originalQuery)
            : [];
}

function getSearchResults(query) {
  return searchIndex.search(query).flatMap((hit) => {
    if (hit.ref == "undefined") return [];
    let pageMatch = pagesIndex.filter((page) => page.href === hit.ref)[0];
    pageMatch.score = hit.score;
    return [pageMatch];
  });
}

function getLunrSearchQuery(query) {
  const searchTerms = query.split(" ");
  if (searchTerms.length === 1) {
    return query;
  }
  query = "";
  for (const term of searchTerms) {
    query += `+${term} `;
  }
  return query.trim();
}

function renderSearchResults(query, results) {
  clearSearchResults();
  updateSearchResults(query, results);
  showSearchResults();
  scrollToTop();
}

function clearSearchResults() {
  const results = document.querySelector(".search-results ul");
  while (results.firstChild) results.removeChild(results.firstChild);
}

function updateSearchResults(query, results) {
  document.getElementById("query").innerHTML = query;
  document.querySelector(".search-results ul").innerHTML =
  results.map(
    (hit) => `
    <li class="search-result-item" data-score="${hit.score.toFixed(2)}">
      <a href="${hit.href}" class="search-result-page-title">${hit.title}</a>
      <p>${createSearchResultBlurb(query, hit.excerpt)}</p>
    </li>
    `
  )
  .join("");

  const searchResultListItems = document.querySelectorAll(".search-results ul li");
  document.getElementById("results-count").innerHTML = searchResultListItems.length;
  document.getElementById("results-count-text").innerHTML = searchResultListItems.length > 1 ? "results" : "result";
  searchResultListItems.forEach(
    (li) => (li.firstElementChild.style.color = getColorForSearchResult(li.dataset.score))
  );
}

function createSearchResultBlurb(query, pageContent) {
  const searchQueryRegex = new RegExp(createQueryStringRegex(query), "gmi");

  let searchResultText = fixPageBreakers(pageContent);

  return ellipsize(searchResultText, MAX_SUMMARY_LENGTH).replace(
    searchQueryRegex,
    "<strong>$&</strong>"
  );
}

function createQueryStringRegex(query) {
    const searchTerms = query.split(" ");
    if (searchTerms.length == 1) {
        return query;
    }
    query = "";
    for (const term of searchTerms) {
        query += `${term}|`;
    }
    query = query.slice(0, -1);
    return `(${query})`;
}

function tokenize(input) {
  return Array.from(input.match(WORD_REGEX));
}

function fixPageBreakers(inputText) {
  const inputTextWords = tokenize(inputText);
  const largeWords = inputTextWords.filter((word) => word.length > 50);

  largeWords.forEach((word) => {
    const chunked = chunkify(word, 20);
    inputText = inputText.replace(word, chunked);
  });
  return inputText;
}

function chunkify(input, chunkSize) {
    let output = "";
    let totalChunks = (input.length / chunkSize) | 0;
    let lastChunkIsUneven = input.length % chunkSize > 0;
    if (lastChunkIsUneven) {
        totalChunks += 1;
    }
    for (let i = 0; i < totalChunks; i++) {
        let start = i * chunkSize;
        let end = start + chunkSize;
        if (lastChunkIsUneven && i === totalChunks - 1) {
            end = input.length;
        }
        output += input.slice(start, end) + " ";
    }
    return output;
}

function ellipsize(input, maxLength) {
  const words = tokenize(input);
  if (words.length <= maxLength) {
    return input;
  }
  return input.slice(0, words[maxLength].end) + "...";
}

function showSearchResults() {
    $("main").addClass("hide-element");
    $(".search-results").removeClass("hide-element");
}

function scrollToTop() {
    const toTopInterval = setInterval(function () {
        const supportedScrollTop = document.body.scrollTop > 0 ? document.body : document.documentElement;
        if (supportedScrollTop.scrollTop > 0) {
            supportedScrollTop.scrollTop = supportedScrollTop.scrollTop - 50;
        }
        if (supportedScrollTop.scrollTop < 1) {
            clearInterval(toTopInterval);
        }
    }, 10);
}

function getColorForSearchResult(score) {
    const warmColorHue = 171;
    const coolColorHue = 212;
    return adjustHue(warmColorHue, coolColorHue, score);
}

function adjustHue(hue1, hue2, score) {
    if (score > 3) return `hsl(${hue1}, 100%, 50%)`;
    const hueAdjust = (parseFloat(score) / 3) * (hue1 - hue2);
    const newHue = hue2 + Math.floor(hueAdjust);
    return `hsl(${newHue}, 100%, 50%)`;
}
const clearSearchButton = document.getElementById('clear-search-results');
clearSearchButton.onclick = (event) => {
    hideSearchResults();
    clearSearchResults();
    document.getElementById("search").value = "";
}

function hideSearchResults() {
    $(".search-results").addClass("hide-element");
    $("main").removeClass("hide-element");
}

initSearchIndex();
